module.exports = __webpack_public_path__ + "img/Industrial park.dc15e537.png";